import { forwardRef } from 'react';

import Link from '@mui/material/Link';
// import { useTheme } from '@mui/material/styles';
import Box, { BoxProps } from '@mui/material/Box';

import { RouterLink } from 'src/routes/components';

// ----------------------------------------------------------------------

export interface LogoProps extends BoxProps {
  disabledLink?: boolean;
}

const Logo = forwardRef<HTMLDivElement, LogoProps>(
  ({ disabledLink = false, sx, ...other }, ref) => {
    // const theme = useTheme();

    // const PRIMARY_LIGHT = theme.palette.primary.light;

    // const PRIMARY_MAIN = theme.palette.primary.main;

    // const PRIMARY_DARK = theme.palette.primary.dark;

    // OR using local (public folder)
    // -------------------------------------------------------
    // const logo = (
    //   <Box
    //     component="img"
    //     src="/logo/logo_single.svg" => your path
    //     sx={{ width: 40, height: 40, cursor: 'pointer', ...sx }}
    //   />
    // );

    const logo = (
      <Box
        ref={ref}
        component="div"
        sx={{
          width: 40,
          height: 40,
          display: 'inline-flex',
          ...sx,
        }}
        {...other}
      >
        {/* <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 512 512">
          <defs>
            <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
              <stop offset="0%" stopColor={PRIMARY_DARK} />
              <stop offset="100%" stopColor={PRIMARY_MAIN} />
            </linearGradient>

            <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
              <stop offset="0%" stopColor={PRIMARY_LIGHT} />
              <stop offset="100%" stopColor={PRIMARY_MAIN} />
            </linearGradient>

            <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
              <stop offset="0%" stopColor={PRIMARY_LIGHT} />
              <stop offset="100%" stopColor={PRIMARY_MAIN} />
            </linearGradient>
          </defs>

          <g fill={PRIMARY_MAIN} fillRule="evenodd" stroke="none" strokeWidth="1">
            <path
              fill="url(#BG1)"
              d="M183.168 285.573l-2.918 5.298-2.973 5.363-2.846 5.095-2.274 4.043-2.186 3.857-2.506 4.383-1.6 2.774-2.294 3.939-1.099 1.869-1.416 2.388-1.025 1.713-1.317 2.18-.95 1.558-1.514 2.447-.866 1.38-.833 1.312-.802 1.246-.77 1.18-.739 1.111-.935 1.38-.664.956-.425.6-.41.572-.59.8-.376.497-.537.69-.171.214c-10.76 13.37-22.496 23.493-36.93 29.334-30.346 14.262-68.07 14.929-97.202-2.704l72.347-124.682 2.8-1.72c49.257-29.326 73.08 1.117 94.02 40.927z"
            />
            <path
              fill="url(#BG2)"
              d="M444.31 229.726c-46.27-80.956-94.1-157.228-149.043-45.344-7.516 14.384-12.995 42.337-25.267 42.337v-.142c-12.272 0-17.75-27.953-25.265-42.337C189.79 72.356 141.96 148.628 95.69 229.584c-3.483 6.106-6.828 11.932-9.69 16.996 106.038-67.127 97.11 135.667 184 137.278V384c86.891-1.611 77.962-204.405 184-137.28-2.86-5.062-6.206-10.888-9.69-16.994"
            />
            <path
              fill="url(#BG3)"
              d="M450 384c26.509 0 48-21.491 48-48s-21.491-48-48-48-48 21.491-48 48 21.491 48 48 48"
            />
          </g>
        </svg> */}
        <svg
          width="95"
          height="61"
          viewBox="0 0 95 61"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M45.7431 60.4375V9.71824L25.037 0.964355V38.0099L45.7431 60.4375Z"
            fill="#D58128"
          />
          <path
            d="M49.2227 0.964355V43.2893L69.9288 60.4375V12.8319L49.2227 0.964355Z"
            fill="#D58128"
          />
          <path
            d="M45.7431 60.4375C32.9884 60.4375 21.5193 52.6704 16.7853 40.8276L0.850586 0.965088C13.6053 0.965088 25.0744 8.73219 29.8084 20.575L45.7431 60.4375Z"
            fill="#F6DB67"
          />
          <path
            d="M34.541 39.2899C35.515 41.7268 32.0609 43.3917 30.7478 41.1194C30.1778 40.1333 29.6728 39.0964 29.2398 38.0135L22.8833 22.112C21.9092 19.6751 25.3633 18.0102 26.6764 20.2826C27.2464 21.2686 27.7515 22.3056 28.1845 23.3884L34.541 39.2899Z"
            fill="#FFEEA4"
          />
          <path
            d="M69.9288 60.4375C57.1741 60.4375 45.705 52.6704 40.971 40.8276L25.0363 0.965088C37.7909 0.965088 49.2601 8.73219 53.9941 20.575L69.9288 60.4375Z"
            fill="#F1C243"
          />
          <path
            d="M58.7266 39.2899C59.7007 41.7268 56.2466 43.3917 54.9335 41.1194C54.3628 40.1333 53.8584 39.0964 53.4254 38.0135L47.0689 22.112C46.0949 19.6751 49.5489 18.0102 50.8621 20.2826C51.4321 21.2686 51.9371 22.3056 52.3701 23.3884L58.7266 39.2899Z"
            fill="#F6DB67"
          />
          <path
            d="M94.1144 60.4375C81.3597 60.4375 69.8906 52.6704 65.1566 40.8276L49.2219 0.965088C61.9766 0.965088 73.4457 8.73219 78.1797 20.575L94.1144 60.4375Z"
            fill="#ECA836"
          />
          <path
            d="M83.0027 39.2899C83.9767 41.7268 80.5226 43.3917 79.2095 41.1194C78.6395 40.1333 78.1345 39.0963 77.7015 38.0135L71.3449 22.1113C70.3709 19.6744 73.8243 18.0095 75.1381 20.2818C75.7081 21.2679 76.2132 22.3048 76.6462 23.3877L83.0027 39.2899Z"
            fill="#F1C243"
          />
        </svg>
      </Box>
    );

    if (disabledLink) {
      return logo;
    }

    return (
      <Link component={RouterLink} href="/" sx={{ display: 'contents' }}>
        {logo}
      </Link>
    );
  }
);

export default Logo;
